import type { TextSizingConfigs } from './utils';
import { devices } from '../common/devices';
import { colors, darkThemeSelector, styled } from '../stitches.config';
import { Text } from './Text';

const subheadingVars = {
  touch: {
    size: 15,
    lineHeight: 24,
  },
  mouse: {
    size: 13,
    lineHeight: 20,
  },
} as const satisfies TextSizingConfigs;

const SubheadingBase = {
  color: colors.headingNeutralLight,
  [darkThemeSelector]: {
    color: colors.headingNeutralDark,
  },
  variants: {
    internal: {
      true: {
        color: colors.internalBodyLight,
        [darkThemeSelector]: {
          color: colors.internalBodyDark,
        },
      },
      false: {},
    },
  },
};

export const SubheadingSansSizes = {
  '&': {
    [devices.touch]: {
      fontSize: `$${subheadingVars.touch.size}`,
      lineHeight: `$${subheadingVars.touch.lineHeight}`,
    },

    [devices.mouse]: {
      fontSize: `$${subheadingVars.mouse.size}`,
      lineHeight: `$${subheadingVars.mouse.lineHeight}`,
    },
  },
};

export const SubheadingMonoSizes = {
  '&': {
    [devices.touch]: {
      fontSize: `$${subheadingVars.touch.size - 1}`,
      lineHeight: `$${subheadingVars.touch.lineHeight}`,
    },

    [devices.mouse]: {
      fontSize: `$${subheadingVars.mouse.size - 1}`,
      lineHeight: `$${subheadingVars.mouse.lineHeight}`,
    },
  },
};

export const Subheading = styled(Text, SubheadingBase, {
  variants: {
    context: {
      body: {},
      heading: {},
    },
    family: {
      regular: SubheadingSansSizes,
      monospace: SubheadingMonoSizes,
    },
    weight: {
      bold: {},
    },
  },
  defaultVariants: {
    context: 'heading',
    family: 'regular',
    weight: 'bold',
  },
});
Subheading.displayName = 'Subheading';
